import { Hero } from '../sections/Hero';
import { JourneyStory } from '../sections/JourneyStory';
import { ProductProof } from '../sections/ProductProof';
import { SupportingStories } from '../sections/SupportingStories';
import { ClosingCta } from '../sections/ClosingCta';
import { useReveal } from '../hooks/useReveal';

/**
 * The marketing page. The reveal hook lives here rather than in App so that it
 * re-arms with the page's own `.tl-reveal` blocks whenever this route mounts.
 */
export const HomePage = () => {
  useReveal();

  return (
    <>
      <Hero />
      <JourneyStory />
      <ProductProof />
      <SupportingStories />
      <ClosingCta />
    </>
  );
};
